<template>
  <div>
    <Page :title="pageTitle" :isFullWidth="true">
      <template v-slot:action>
        <div class="Polaris-Page-Header__PrimaryActionWrapper">
          <div class="Polaris-Box Polaris-Box--printHidden">
            <button
              class="Polaris-Button Polaris-Button--primary"
              type="button"
              @click="refreshCurrentPage"
              :disabled="isLoading"
            >
              <span class="Polaris-Button__Content">
                <span class="Polaris-Button__Text"
                  >Refresh<span v-if="isLoading">ing</span></span
                >
              </span>
            </button>
          </div>
        </div>
      </template>
      <template v-slot:default>
        <div class="flex flex-col max-w-7xl mx-auto my-10">
          <div
            class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8"
          >
            <div v-if="isLoading">
              <Spinner />
            </div>

            <div class="flex flex-col">
              <div
                class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8 "
              >
                <div
                  class="align-middle inline-block min-w-full shadow  sm:rounded-lg border-b border-gray-200 mb-24"
                >
                  <div class="Polaris-Card">
                    <div class="">
                      <div class="Polaris-DataTable__Navigation">
                        <button
                          class="Polaris-Button Polaris-Button--disabled Polaris-Button--plain Polaris-Button--iconOnly"
                          aria-label="Scroll table left one column"
                          aria-disabled="true"
                          type="button"
                          tabindex="-1"
                        >
                          <span class="Polaris-Button__Content">
                            <span class="Polaris-Button__Icon">
                              <span class="Polaris-Icon">
                                <span
                                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                >
                                </span>
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M12 16a.997.997 0 0 1-.707-.293l-5-5a.999.999 0 0 1 0-1.414l5-5a.999.999 0 1 1 1.414 1.414l-4.293 4.293 4.293 4.293a.999.999 0 0 1-.707 1.707z"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </span>
                        </button>
                        <button
                          class="Polaris-Button Polaris-Button--plain Polaris-Button--iconOnly"
                          aria-label="Scroll table right one column"
                          type="button"
                        >
                          <span class="Polaris-Button__Content">
                            <span class="Polaris-Button__Icon">
                              <span class="Polaris-Icon">
                                <span
                                  class="Polaris-Text--root Polaris-Text--bodySm Polaris-Text--regular Polaris-Text--visuallyHidden"
                                >
                                </span>
                                <svg
                                  viewBox="0 0 20 20"
                                  class="Polaris-Icon__Svg"
                                  focusable="false"
                                  aria-hidden="true"
                                >
                                  <path
                                    d="M8 16a.999.999 0 0 1-.707-1.707l4.293-4.293-4.293-4.293a.999.999 0 1 1 1.414-1.414l5 5a.999.999 0 0 1 0 1.414l-5 5a.997.997 0 0 1-.707.293z"
                                  ></path>
                                </svg>
                              </span>
                            </span>
                          </span>
                        </button>
                      </div>
                      <div
                        class="Polaris-DataTable Polaris-DataTable__ShowTotals overflow-auto"
                      >
                        <div class="">
                          <table class="Polaris-DataTable__Table">
                            <thead>
                              <tr class="hidden md:table-row">
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header"
                                  scope="col"
                                >
                                  Subscriber
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Browser
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  OS
                                </th>
                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Device Used
                                </th>

                                <th
                                  data-polaris-header-cell="true"
                                  class="Polaris-DataTable__Cell Polaris-DataTable__Cell--verticalAlignTop Polaris-DataTable__Cell--header "
                                  scope="col"
                                >
                                  Date
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <SubscriberItem
                                v-for="subscriber in subscribers.docs"
                                :key="subscriber.id"
                                :subscriber="subscriber"
                                :shop-origin="shopOrigin"
                              />
                            </tbody>
                          </table>
                        </div>

                        <Pagination
                          :page="subscribers"
                          @pageChanged="loadPage"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="align-middle inline-block min-w-full  overflow-hidden text-center py-16"
                  v-if="
                    !isLoading &&
                      subscribers.docs &&
                      subscribers.docs.length === 0
                  "
                >
                  You don't have any subscribers right now. We will be listing
                  them here as soon as customer is subscribed.
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Page>
  </div>
</template>

<script>
import Spinner from "vue-simple-spinner";

import Page from "../components/Common/Page.vue";

import SubscriberItem from "../components/Common/SubscriberItem";

import Pagination from "../components/Common/Pagination";

export default {
  name: "Subscribers",
  data() {
    return {
      pageTitle: "Subscribers",
      isLoading: false,
      subscribers: {},
      currentCustomerPhoneNumber: null,
      showCustomerInfoModal: false
    };
  },
  components: {
    Page,
    SubscriberItem,
    Pagination,
    Spinner
  },
  computed: {
    config() {
      return this.$store.getters.getConfig;
    },
    shopOrigin() {
      const { shopOrigin } = this.$store.getters.getStore;
      return shopOrigin;
    }
  },
  created() {
    this.loadPage(1);
    this.$store.dispatch("getConfig");
  },
  methods: {
    async loadPage(page) {
      this.isLoading = true;
      const response = await this.$store.dispatch("getSubscribers", {
        page
      });
      this.subscribers = response.subscribers;
      this.isLoading = false;
    },
    refreshCurrentPage() {
      const page = this.subscribers.page;
      this.loadPage(page);
    }
  }
};
</script>

<style lang="scss" scoped></style>
